import React from "react";
import { Field } from "formik";

const RadioButton = ({ name, value, label }) => {
  return (
    <Field name={name}>
      {({ field }) => {
        const checked = field.value === value;
        return (
          <label className="cursor-pointer select-none">
            <input
              type="radio"
              {...field}
              value={value}
              checked={checked}
              className="sr-only"
            />
            <span
              className="inline-flex items-center px-4 py-2.5 text-sm font-semibold rounded-lg border transition-all duration-150"
              style={
                checked
                  ? { borderColor: "var(--acc)", background: "var(--acc)", color: "var(--acc-fg)" }
                  : { borderColor: "var(--line-2)", background: "hsl(var(--card))" }
              }
            >
              {label}
            </span>
          </label>
        );
      }}
    </Field>
  );
};

export default RadioButton;
